var _defs, _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCircleButtonover3(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Circle_Button_over",
    "data-name": "Circle Button over",
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #bbe36c;\n      }\n\n      .cls-2 {\n        fill: rgba(253,73,198,0.35);\n        opacity: 0;\n      }\n\n      .cls-3 {\n        fill: #2f2f2f;\n      }\n    "))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Area_SIZE:MEDIUM_STATE:DEFAULT_STYLE:STYLE2_",
    "data-name": "Area [SIZE:MEDIUM][STATE:DEFAULT][STYLE:STYLE2]",
    className: "cls-1",
    width: 48,
    height: 48,
    rx: 24
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon_ICON_feather_youtube_SIZE_MEDIUM_STATE_DEFAULT_STYLE_STYLE2_",
    "data-name": "Icon [ICON=feather/youtube][SIZE=MEDIUM][STATE=DEFAULT][STYLE=STYLE2]",
    transform: "translate(14 14)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Area_ICON:feather_youtube_SIZE:MEDIUM_STATE:DEFAULT_STYLE:STYLE2_",
    "data-name": "Area [ICON:feather/youtube][SIZE:MEDIUM][STATE:DEFAULT][STYLE:STYLE2]",
    className: "cls-2",
    width: 20,
    height: 20
  }), /*#__PURE__*/React.createElement("g", {
    id: "Icon",
    transform: "translate(1.667 1.667)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "_80c62489-cee6-427c-9b21-f44ffe0486a2",
    "data-name": "80c62489-cee6-427c-9b21-f44ffe0486a2",
    className: "cls-3",
    d: "M10.908,2.727a61.747,61.747,0,0,1,8.034.408l.031.008a3.444,3.444,0,0,1,2.4,2.472q.007.03.013.06a27.392,27.392,0,0,1,.432,5.007,27.5,27.5,0,0,1-.432,4.933q-.005.03-.013.06a3.447,3.447,0,0,1-2.4,2.472l-.013,0c-1.632.436-7.4.449-8.053.449s-6.421-.013-8.052-.449l-.006,0a3.458,3.458,0,0,1-2.4-2.374q-.012-.043-.02-.088A27.38,27.38,0,0,1,0,10.681a27.356,27.356,0,0,1,.432-4.97q.005-.03.013-.06a3.447,3.447,0,0,1,2.4-2.472l.013,0C4.487,2.74,10.256,2.727,10.908,2.727ZM18.494,4.9a61.8,61.8,0,0,0-7.586-.352,53.447,53.447,0,0,0-7.575.385A1.625,1.625,0,0,0,2.216,6.066a25.533,25.533,0,0,0-.4,4.61s0,.007,0,.01a25.558,25.558,0,0,0,.395,4.629,1.63,1.63,0,0,0,1.116,1.079,53.252,53.252,0,0,0,7.579.386,53.466,53.466,0,0,0,7.576-.385A1.625,1.625,0,0,0,19.6,15.26a25.679,25.679,0,0,0,.4-4.576s0-.006,0-.008a25.572,25.572,0,0,0-.4-4.645A1.622,1.622,0,0,0,18.494,4.9Z",
    transform: "translate(-2.575 -2.33)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_00db3492-04f1-46cb-b10e-63c254dc76bd",
    "data-name": "00db3492-04f1-46cb-b10e-63c254dc76bd",
    className: "cls-3",
    d: "M8.863,14.563a.909.909,0,0,1-.909-.909V7.709a.909.909,0,0,1,1.358-.79l5.227,2.972a.909.909,0,0,1,0,1.58L9.312,14.444A.908.908,0,0,1,8.863,14.563Zm.909-5.291v2.82l2.479-1.41Z",
    transform: "translate(-2.575 -2.33)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleButtonover3);
export default __webpack_public_path__ + "static/media/Circle Button over-3.edd70f0c67e2d0f5581208a4875bd2d2.svg";
export { ForwardRef as ReactComponent };